import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue")
  },
  {
    path: "/nouvelleCommande",
    name: "nouvelleCommande",
    component: () => import("../views/NouvelleCommande.vue")
  },
  {
    path: "/historique",
    name: "historique",
    component: () => import("../views/Historique.vue")
  },
  {
    path: "/ticket/:id",
    name: "ticket",
    component: () => import("../views/ShowTicket.vue")
  },
  {
    path: "/clients",
    name: "clients",
    component: () => import("../views/Clients.vue")
  },
  {
    path: "/client/:id",
    name: "client",
    component: () => import("../views/ShowClient.vue")
  },
  {
    path: "/statistiques",
    name: "statistiques",
    component: () => import("../views/Statistiques.vue")
  },
  {
    path: "/debug",
    name: "debug",
    component: () => import("../views/debug/Main.vue")
  },
  {
    path: "*",
    name: "notfound",
    component: () => import("../views/NotFound.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
